<template>
    <div>
        <div class="form-group ">
            <label :for="name" v-if="!hideLabel">{{label}}</label>
            <textarea v-validate="rules"
                      @input="inputValue"
                      :id="name"

                      :data-vv-as="label"
                        rows="10"
                      type="text"
                      :placeholder="placeholder"
                      class="form-control"
                      :class="{'is-invalid':errors.has(name)}"
                      :name="name">{{value}}</textarea>
            <div v-if="errors.has(name)" class="invalid-feedback">
                {{errors.first(name)}}
            </div>


        </div>

    </div>
</template>

<script>

    import mixinField from '../../mixins/mixinField';
    export default {
        mixins: [mixinField],
        name: "FieldTextarea",
        data() {
            return {
                rules:""
            }
        },



    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/fields/FieldTextarea.vue